import { setMessage } from "../../reducers/socketSlice";
import store from "../../store/store";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

export class WebSocketService {
  private static _webSocketService: WebSocketService;

  public static getInstance(): WebSocketService {
    if (!WebSocketService._webSocketService) {
      WebSocketService._webSocketService = new WebSocketService();
    }
    return WebSocketService._webSocketService;
  }

  public connectWebSocket = (userUid: any) => {
    let broker = process.env.REACT_APP_BROKER_URL;
    let sockJs = process.env.REACT_APP_WEB_SOCKET_URL;
    if (sockJs) {
      const client = new Client({
        brokerURL: broker,
        webSocketFactory: () => new SockJS(sockJs),
        connectHeaders: {
          userUid: userUid, // Gửi userUid khi kết nối
        },
        onConnect: () => {
          console.log("Connected !");
          client.subscribe(`/queue/private-${userUid}`, (message) => {
            store.dispatch(setMessage(message.body));
          });
        },
        onUnhandledMessage: (msg: any) => {
          console.log("onUnhandledMessage", msg);
        },
        onStompError: (frame) => {
          console.error("Broker reported error:", frame.headers["message"]);
        },
        onWebSocketError: (error) => {
          console.error("WebSocket Error:", error);
        },
      });
      client.activate();
    }
  };
}
